module.exports = __webpack_public_path__ + "img/404.3bc39a45.png";